<template>
  <div>
    <v-text-field
      v-model="localEmail"
      :disabled="readonly"
      :rules="emailRules"
      dense
      label="E-Posta"
      validate-on-blur
      @input="onInput"
    />
    <v-progress-linear
      v-if="emailChecking"
      color="blue-grey"
      indeterminate
    ></v-progress-linear>
  </div>
</template>

<script>
export default {
  props: {
    email: {
      type: String,
      default: "",
    },
    user_id: Number,
    required: Boolean,
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localEmail: this.email,
      emailChecking: false,
      checkTimeout: null,
      isEmailUnique: true,
    };
  },
  watch: {
    email: {
      immediate: true,
      handler(newVal) {
        this.localEmail = newVal;
      },
    },
  },
  methods: {
    onInput(value) {
      this.localEmail = (value || "").toLowerCase();
      this.$emit("update:email", value); // userData.email güncellenmesi için
      this.checkEmailIsUnique(value);
    },
    async checkEmailIsUnique(value) {
      if (!value) return;
      if (this.checkTimeout) clearTimeout(this.checkTimeout);
      this.checkTimeout = setTimeout(async () => {
        this.emailChecking = true;
        try {
          await this.$apiService.post("/email/verify", {
            email: value,
            user_id: this.user_id,
          });
          this.isEmailUnique = true;
        } catch {
          this.isEmailUnique = false;
        } finally {
          this.emailChecking = false;
        }
      }, 1500);
    },
  },
  computed: {
    emailRules() {
      const rules = [];

      rules.push(
        (v) =>
          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(v) ||
          "Geçerli bir e-posta adresi giriniz (Türkçe karakter kullanmayınız)"
      );

      if (!this.isEmailUnique) {
        rules.push(() => "Bu e-posta adresi kullanılmaktadır");
      }

      return rules;
    },
  },
};
</script>
